import { render, staticRenderFns } from "./CrudPesquisa.vue?vue&type=template&id=68094325"
import script from "./CrudPesquisa.vue?vue&type=script&lang=ts"
export * from "./CrudPesquisa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports